import { EditorV3DropListItem } from "../interface";

/**
 * Render a single dropdown list item into the provided `ul` element.
 * Ensures the list item has the expected classes, dataset attributes,
 * and text content, and appends it to the dropdown container.
 *
 * @param dropdownUl - The `ul` element to append the item into.
 * @param dropItem - The item data used to render or update the `li`.
 */
export const renderListItem = (
  dropdownUl: HTMLUListElement,
  dropItem: EditorV3DropListItem<Record<string, string>>,
) => {
  const dropSpan = dropItem.listRender ?? document.createElement("li");
  /* istanbul ignore else */
  if (!dropSpan.classList.contains("aiev3-drop-item")) dropSpan.classList.add("aiev3-drop-item");
  /* istanbul ignore else */
  if (!dropSpan.dataset.text) dropSpan.dataset.text = dropItem.text;
  /* istanbul ignore else */
  if (dropSpan.textContent === "" || !dropSpan.textContent) dropSpan.textContent = dropItem.text;
  // Add in data from atItem
  /* istanbul ignore else */
  if (dropItem.data)
    Object.keys(dropItem.data).forEach((key) => {
      /* istanbul ignore else */
      if (dropItem.data) dropSpan.dataset[key] = dropItem.data[key];
    });
  dropdownUl.appendChild(dropSpan);
};
